import { NavigationContainer } from '@react-navigation/native'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import BottomSheetHeader from '@zet/common/components/bottomSheetHeader'
import StackHeader from '@zet/common/components/header/stackHeader'
// import NetworkCallsScreen from '../screens/networkCallsScreen'
import { LinkBroken } from '@zet/common/components/linkBroken'
import { WebViewScreen } from '@zet/common/components/webView'
import {
  BrandEligibleCustomers,
  CustomerBasicDetails,
  CustomerBasicDetailsV2,
  EmploymentDetails,
  OtpLess,
  PanDetails,
  PanDetailsV2,
  VerifyCustomerOtp,
} from '@zet/customer'
import VerifyCustomerConsent from '@zet/customer/src/screens/VerifyCustomerConsent'
import EditCustomerDetails from '@zet/customer/src/screens/editCustomerDetails'
import MyCustomers from '@zet/customer/src/screens/myCustomers/MyCustomers'
import VerifySecondaryPhoneNumber from '@zet/customer/src/screens/verifySecondaryPhoneNumber'
import VerifySecondaryPhoneOtp from '@zet/customer/src/screens/verifySecondaryPhoneOtp'
import ApplicationProcess from '@zet/feature-brands/screens/applicationProcess'
import { BrandBenefits } from '@zet/feature-brands/screens/brandBenefits'
import BrandDetails from '@zet/feature-brands/screens/brandDetails'
import BrandShareDetails from '@zet/feature-brands/screens/brandDetails/brandShareDetails'
import ShareCardLink from '@zet/feature-brands/screens/brandDetails/shareCardLink'
import BrandSpecificRecommendationLoader from '@zet/feature-brands/screens/brandSpecificRecommendationLoader'
import { BrandsHelpAndSupport } from '@zet/feature-brands/screens/brandsHelpAndSupport'
import { EligibilityCriteria } from '@zet/feature-brands/screens/eligibilityCriteria'
import { InEligibleBrandsList } from '@zet/feature-brands/screens/inEligibleBrandsList'
import MarketingResource from '@zet/feature-brands/screens/marketingResource'
import ProductList from '@zet/feature-brands/screens/productList'
import { LeadProgress } from '@zet/feature-leads'
import { FrequentlyAskedQuestions } from '@zet/feature-leads/screens/FrequentlyAskedQuestions'
import { BrandLeads } from '@zet/feature-leads/screens/brandLeads'
import { CustomerLead } from '@zet/feature-leads/screens/customerLead'
import { LeadsHelp } from '@zet/feature-leads/screens/leadsHelp'
import { i18n } from '@zet/localization'
import { TrainingVideoPlayer } from '@zet/trainings'
import {
  AccountBlockedScreen,
  NetworkIssueScreen,
  ServerDownScreen,
} from '@zet/utils'
import { navigationRef } from '@zet/utils/navigation'

// import NetworkCallsScreen from '../screens/networkCallsScreen'
import CrifTermsOfUse from '@screens/crifTermsOfuse'
import ExperianTermsOfUse from '@screens/experianTermsOfUse'

import HeaderWithTitle from '../components/headerWithTitle'
import AccountDetails from '../screens/accountDetails'
import Faqs from '../screens/accountDetails/Faqs'
import EnterOtpScreen from '../screens/addCustomer/enterOtpScreen'
import { AddBankAccount } from '../screens/addPaymentDetails'
import EditBankAccountDetails from '../screens/editBankAccountDetails'
import EditDetails from '../screens/editDetails'
import IdCard from '../screens/idCard'
import { KnowCustomerScreen } from '../screens/knowYourCustomerScreen'
import MultipleAccount from '../screens/login/multipleAccount'
import SignupSuccess from '../screens/login/signupSuccess'
import UserDetails from '../screens/login/userDetails'
import { default as VerifyOtp } from '../screens/login/verifyOtp'
import { default as VerifyPhoneNumber } from '../screens/login/verifyPhoneNumber'
import PrivacyPolicy from '../screens/privacyPolicy'
import Splash from '../screens/splash'
import TDS from '../screens/tds'
import TeamEarningsPage from '../screens/teamEarningsPage'
import TermsOfUse from '../screens/termsOfUse'
import BottomTabNavigation from './BottomTabNavigation'

const PrivateStack = createNativeStackNavigator()
const screenWithNoHeader = { headerShown: false }

const linking = {
  prefixes: ['https://myteamsadvisor.com', 'myteamsadvisor://'],
  config: {
    screens: {
      VerifyPhoneNumber: '/verify-phone-number',
      VerifyOtp: '/verify-otp',
      HomeView: {
        screens: {
          HomeScreen: 'home',
          Products: 'products',
          Leads: 'leads',
        },
      },
      // MultipleAccount: '/select-dsa',
      KnowYourCustomer: '/name-and-phone-number',
      BrandShareDetails: '/brand-share-details',
      LeadProgress: '/lead-details',
      ApplicationProcess: '/application-process',
      BrandPage: '/brands',
      BrandDetails: '/brand-details',
      ShareCardLink: '/share-card-link',
      AccountDetails: '/account-details',
      EditDetails: '/edit-details',
      Faqs: '/faqs',
      MyCustomers: {
        path: '/my-customers',
        screens: {
          VerifiedCustomers: 'verified-customers',
          NonVerifiedCustomers: 'non-verified-customers',
        },
      },
      // recommendations: '/recommendations',
      EditCustomerDetails: '/edit-customer-details',
      BrandBenefits: '/brand-benefits',
      EligibilityCriteria: '/eligibility-criteria',
      MarketingResource: '/marketing-resource',
      BrandsHelpAndSupport: '/brands-help-and-support',
      LinkBroken: 'link-broken',
      Splash: '/',
      PrivacyPolicy: '/privacy-policy',
      TermsOfUse: '/terms-of-use',
    },
  },
}

const Root = () => {
  return (
    <NavigationContainer linking={linking} ref={navigationRef}>
      <PrivateStack.Navigator screenOptions={{ animation: 'slide_from_right' }}>
        {LoggedIn()}
      </PrivateStack.Navigator>
      {/* <NetworkCall /> */}
    </NavigationContainer>
  )
}
const LoggedIn = () => (
  <PrivateStack.Group>
    <PrivateStack.Screen
      name="Splash"
      component={Splash}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="HomeView"
      component={BottomTabNavigation}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="AccountDetails"
      component={AccountDetails}
      options={{ header: () => <HeaderWithTitle title="Account Details" /> }}
    />
    <PrivateStack.Screen
      name="EditDetails"
      component={EditDetails}
      options={{
        header: () => <HeaderWithTitle title="Edit Details" icon="Cross" />,
      }}
    />
    <PrivateStack.Screen
      name="MultipleAccount"
      component={MultipleAccount}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="UserDetails"
      component={UserDetails}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="KnowYourCustomer"
      component={KnowCustomerScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="EnterOtpScreen"
      component={EnterOtpScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="VerifyCustomerOtp"
      component={VerifyCustomerOtp}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="VerifyCustomerConsentScreen"
      component={VerifyCustomerConsent}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="CustomerBasicDetails"
      component={CustomerBasicDetails}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="EmploymentDetails"
      component={EmploymentDetails}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="BrandPage"
      component={ProductList}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="BrandSpecificRecommendationLoader"
      component={BrandSpecificRecommendationLoader}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="BrandDetails"
      component={BrandDetails}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="ArrowBack"
            isGoBack={true}
            title={''}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="BrandBenefits"
      component={BrandBenefits}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.brandBenefits')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="ApplicationProcess"
      component={ApplicationProcess}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.applicationProcess')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="EligibilityCriteria"
      component={EligibilityCriteria}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.eligibilityCriteria')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="WebViewScreen"
      component={WebViewScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="MarketingResource"
      component={MarketingResource}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.marketingResource')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="BrandsHelpAndSupport"
      component={BrandsHelpAndSupport}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.helpSupport')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="ShareCardLink"
      component={ShareCardLink}
      options={{
        header: () => (
          <BottomSheetHeader
            primaryIcon="Share"
            title={i18n.t('navigationHeading.shareCardLink')}
            eventName="cross_button"
            eventPayload={{ screen_name: 'share_card_link' }}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="BrandShareDetails"
      component={BrandShareDetails}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
          />
        ),
      }}
    />
    {/* <PrivateStack.Screen
      name="recommendations"
      component={ProductList}
      options={screenWithNoHeader}
    /> */}
    <PrivateStack.Screen
      name="MyCustomers"
      component={MyCustomers}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="InEligibleBrandsList"
      component={InEligibleBrandsList}
      options={{
        header: (props) => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            title={i18n.t('headerInEligibleBrands', {
              count: props?.route?.params?.listData?.length,
            })}
            isGoBack={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="EditCustomerDetails"
      component={EditCustomerDetails}
      options={{
        header: () => (
          <HeaderWithTitle title="Edit Customer Details" icon="Cross" />
        ),
      }}
    />
    <PrivateStack.Screen
      name="LeadProgress"
      component={LeadProgress}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="LeadsHelp"
      component={LeadsHelp}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="CustomerLead"
      component={CustomerLead}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            title="Leads"
            isGoBack={true}
            isPrimaryIconShadow={true}
          />
        ),
      }}
    />
    <PrivateStack.Screen
      name="BrandLeads"
      component={BrandLeads}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="BrandCustomers"
      component={BrandEligibleCustomers}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="FrequentlyAskedQuestions"
      component={FrequentlyAskedQuestions}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="PanDetails"
      component={PanDetails}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="PanDetailsV2"
      component={PanDetailsV2}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="CustomerBasicDetailsV2"
      component={CustomerBasicDetailsV2}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="VerifySecondaryPhoneNumber"
      component={VerifySecondaryPhoneNumber}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="VerifySecondaryPhoneOtp"
      component={VerifySecondaryPhoneOtp}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="OtpLess"
      component={OtpLess}
      options={{
        header: () => <StackHeader isAddCustomerFlow />,
      }}
    />
    <PrivateStack.Screen
      name="AccountBlockedScreen"
      component={AccountBlockedScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="NetworkIssueScreen"
      component={NetworkIssueScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="ServerDownScreen"
      component={ServerDownScreen}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="Faqs"
      component={Faqs}
      options={{
        header: () => (
          <BottomSheetHeader
            isSecondaryIcon={false}
            primaryIcon="Close"
            isGoBack={true}
            title={i18n.t('navigationHeading.helpSupport')}
            isHeaderShadow={true}
          />
        ),
      }}
    />
    {/* <PrivateStack.Screen
      name="NetworkCallsScreen"
      component={NetworkCallsScreen}
      options={screenWithNoHeader}
    /> */}
    <PrivateStack.Screen
      name="LinkBroken"
      component={() => (
        <LinkBroken message={'Something went wrong. Please try again later.'} />
      )}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="IdCard"
      component={IdCard}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="VerifyPhoneNumber"
      component={VerifyPhoneNumber}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="VerifyOtp"
      component={VerifyOtp}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="SignupSuccess"
      component={SignupSuccess}
      options={screenWithNoHeader}
    />
    {/* <SignupStack.Screen
      name="NetworkCallsScreen"
      component={NetworkCallsScreen}
      options={screenWithNoHeader}
    /> */}
    <PrivateStack.Screen
      name="TermsOfUse"
      component={TermsOfUse}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="PrivacyPolicy"
      component={PrivacyPolicy}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="CrifTermsOfUse"
      component={CrifTermsOfUse}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="TraingVideoPlayer"
      component={TrainingVideoPlayer}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="TeamEarningsPage"
      component={TeamEarningsPage}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="AddBankAccount"
      component={AddBankAccount}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="EditBankAccountDetails"
      component={EditBankAccountDetails}
      options={screenWithNoHeader}
    />
    <PrivateStack.Screen
      name="TDS"
      component={TDS}
      options={{ headerShown: false }}
    />
    <PrivateStack.Screen
      name="ExperianTermsOfUse"
      component={ExperianTermsOfUse}
      options={screenWithNoHeader}
    />
  </PrivateStack.Group>
)

export default Root
